// globals: jQuery, Ajax, reportAjaxError

import { I4goFrameDialogService } from './I4goFrameDialogForm';

var I4goIframeDialogCardIsExpired = {

    i4goFrameDialogService: null,

    init: function() {
        this.i4goFrameDialogService = new I4goFrameDialogService();
    },

    openDialog: function(userId, i4goIframeDialogOptions) {
        var self = this;
        this.init();
        this.i4goFrameDialogService.open(
            function(form, data) {
                data.user_id = userId;
                self.cardSave(data);
            },
            {
                dialogOptions: {
                    title: '<b>Enter Credit/Debit Card to store on file</b>'
                },
                i4goIframeDialogOptions: i4goIframeDialogOptions
            }
        );
    },

    cardSave: function(data) {

        var url = '/i4go/save-card';

        new Ajax.Request(
            url,
            {
                parameters: data,
                onComplete: function(request) {
                    var result = request.responseJSON;
                    if (result.status === 0) {
                        jQuery.caAlert(result.error);
                        return false;
                    }
                    location.reload();

                },
                onFailure: reportAjaxError
            }
        );
    }
};

export default I4goIframeDialogCardIsExpired;
